<template>
  <el-card
    class="ds-detail"
    style="position: relative; z-index: 0; width: 100%"
  >
    <div slot="header" class="clearfix">
      <el-button @click="$router.back()" class="pull-left">
        <i class="fa fa-chevron-left fa-fw"></i> 返回 </el-button
      >&nbsp;
      <el-tag size="medium">{{ item.Name }}</el-tag>
    </div>
    <div style="margin-bottom: 15px">
      <div class="border-style">产品信息</div>
      <table
        border="1"
        bordercolor="#dedede"
        style="width: 100%; border-collapse: collapse"
      >
        <tr>
          <th width="15%">产品名称</th>
          <td width="35%">{{ item.Name }}</td>
          <th width="15%">业务类型</th>
          <td width="35%">
            {{ item.BusinessType ? item.BusinessType.Name : "" }}
          </td>
        </tr>
        <tr>
          <th>最新发布日期</th>
          <td>
            <div v-if="item.LatestVersion && item.LatestVersion.CreatedAt">
              {{ item.LatestVersion.CreatedAt.substring(0, 10) }}
            </div>
            <div v-else></div>
          </td>
          <th>最新版本号</th>
          <td>
            <div v-if="item.LatestVersion">
              {{ item.LatestVersion.Version }}
            </div>
            <div v-else></div>
          </td>
        </tr>
        <tr>
          <th colspan="1">升级路径</th>
          <td colspan="3">
            <div v-if="item.Route">
              <el-steps :active="100" finish-status="wait">
                <el-step
                  icon="fas fa-circle"
                  v-for="r in item.Route"
                  :key="r.Version"
                >
                  <span style="color: black" slot="title">{{ r.Version }}</span>
                </el-step>
              </el-steps>
            </div>
            <div v-else></div>
          </td>
        </tr>
      </table>
    </div>
    <div style="margin-bottom: 10px">
      <div class="border-style">版本记录</div>
      <el-timeline>
        <el-timeline-item
          placement="top"
          :timestamp="version.CreatedAt.substring(0, 10)"
          v-for="version in item.Versions"
          :key="version.ID"
        >
          <el-card>
            <span style="color: #409eff" class="clearfix">
              <span style="font-weight: 600"
                >版本:&nbsp;{{ version.Version }}</span
              >
              <span style="font-size: 10px"></span>
              <el-tag v-if="version.Status === 1" style="margin-left: 10px">
                启用
              </el-tag>
              <el-tag
                v-if="version.Status === 2"
                type="danger"
                style="margin-left: 10px"
              >
                停运
              </el-tag>
              <span style="font-size: 10px"> &nbsp;&nbsp;功能版本:</span>
              <el-tag
                v-for="tag in version.VersionFunctions"
                :key="tag.ID"
                style="margin-left: 10px"
                >{{ tag.Name }}</el-tag
              >
              <span style="font-size: 10px"> &nbsp;&nbsp;通讯协议:</span>
              <el-tag
                v-for="comm in version.CommProtocols"
                :key="comm.ID"
                style="margin-left: 10px"
                >{{ comm.Name }}</el-tag
              >
              <el-button
                type="primary"
                size="mini"
                @click.stop="onUpdateDrive(version)"
                title="发布驱动"
                style="float: right; margin-left: 10px; margin-right: 10px"
                :disabled="version.CheckStatus === 1"
                >发布驱动</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click.stop="onUpdatePatch(version)"
                title="发布补丁"
                style="float: right"
                :disabled="version.CheckStatus === 1"
                >发布补丁</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click.stop="onUpdateAttachment(version)"
                title="管理附件"
                style="float: right"
                :disabled="version.CheckStatus === 1"
                >管理附件</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click.stop="onUpdateVersion(version)"
                title="编辑版本"
                style="float: right"
                :disabled="version.CheckStatus === 1"
                >编辑版本</el-button
              >
            </span>
            <el-card style="margin-top: 10px"
              ><div v-html="version.UpdateLog"></div
            ></el-card>
            <el-collapse @change="handleChange">
              <el-collapse-item>
                <template slot="title">
                  <span style="font-size: 14px; font-weight: 600"
                    >补丁更新日志</span
                  >
                </template>
                <el-timeline>
                  <el-timeline-item
                    v-for="branch in version.VersionBranchs"
                    :key="branch.ID"
                    :timestamp="branch.CreatedAt.substring(0, 10)"
                    placement="top"
                  >
                    <el-card>
                      <div v-html="branch.UpdateLog"></div>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </el-collapse-item>
              <el-collapse-item>
                <template slot="title">
                  <span style="font-size: 14px; font-weight: 600"
                    >驱动更新日志</span
                  >
                </template>
                <el-timeline>
                  <el-timeline-item
                    v-for="drive in version.VersionDrives"
                    :key="drive.ID"
                    :timestamp="drive.CreatedAt.substring(0, 10)"
                    placement="top"
                  >
                    <el-card>
                      <div v-html="drive.UpdateLog"></div>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </el-collapse-item>
              <el-collapse-item>
                <template slot="title">
                  <span style="font-size: 14px; font-weight: 600">发布库</span>
                </template>
                <el-tabs v-model="activeTab">
                  <el-tab-pane label="版本包" name="tabBranch">
                    <el-table :data="version.PublishBranchs" max-height="500">
                      <el-table-column
                        type="index"
                        width="40"
                      ></el-table-column>
                      <el-table-column prop="Name" label="版本包名称">
                        <template slot-scope="scope">
                          <div v-if="scope.row.DeletedAt" style="color: red">
                            {{ scope.row.Name }}
                          </div>
                          <div v-else>
                            {{ scope.row.Name }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="Md5" label="MD5" width="280">
                      </el-table-column>
                      <el-table-column
                        prop="Provider"
                        label="发布人"
                        width="80"
                      />
                      <el-table-column label="发布日期" width="100">
                        <template slot-scope="scope">
                          <div v-if="scope.row.UpdatedAt">
                            {{ $sys.dateFormat(scope.row.UpdatedAt, "Y-m-d") }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="删除时间" width="150">
                        <template slot-scope="scope">
                          <div v-if="scope.row.DeletedAt">
                            {{
                              $sys.dateFormat(scope.row.DeletedAt, "Y-m-d H:i")
                            }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="DeleteDesc"
                        label="删除原因"
                        width="150"
                        show-overflow-tooltip
                        ><template scope="scope">
                          <span>{{ scope.row.DeleteDesc }}</span>
                        </template>
                      </el-table-column>

                      <el-table-column width="80" label="操作">
                        <template slot-scope="scope">
                          <el-button
                            type="danger"
                            @click.stop="onBranchDeleteClick(scope.row)"
                            title="删除"
                            :disabled="scope.row.DeletedAt !== null"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-tab-pane>
                  <el-tab-pane label="驱动包" name="tabDrive">
                    <el-table :data="version.PublishDrives" max-height="500">
                      <el-table-column
                        type="index"
                        width="40"
                      ></el-table-column>
                      <el-table-column prop="Name" label="驱动包名称">
                        <template slot-scope="scope">
                          <div v-if="scope.row.DeletedAt" style="color: red">
                            {{ scope.row.Name }}
                          </div>
                          <div v-else>
                            {{ scope.row.Name }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="Md5" label="MD5" width="280">
                      </el-table-column>
                      <el-table-column
                        prop="Provider"
                        label="发布人"
                        width="80"
                      />
                      <el-table-column label="发布日期" width="100">
                        <template slot-scope="scope">
                          <div v-if="scope.row.CreatedAt">
                            {{ $sys.dateFormat(scope.row.CreatedAt, "Y-m-d") }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="删除时间" width="150">
                        <template slot-scope="scope">
                          <div v-if="scope.row.DeletedAt">
                            {{
                              $sys.dateFormat(scope.row.DeletedAt, "Y-m-d H:i")
                            }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="DeleteDesc"
                        label="删除原因"
                        width="150"
                        show-overflow-tooltip
                        ><template scope="scope">
                          <span>{{ scope.row.DeleteDesc }}</span>
                        </template>
                      </el-table-column>

                      <el-table-column width="80" label="操作">
                        <template slot-scope="scope">
                          <el-button
                            type="danger"
                            @click.stop="onDriveDeleteClick(scope.row)"
                            title="删除"
                            :disabled="scope.row.DeletedAt !== null"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-tab-pane>
                </el-tabs>
              </el-collapse-item>
            </el-collapse>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>

    <update-patch
      v-model="chuan"
      :visible.sync="updateVisible"
      @form:saved="getItemData"
    />
    <update-drive
      v-model="chuan"
      :visible.sync="driveVisible"
      @form:saved="getItemData"
    />
    <update-attachment
      v-model="chuan"
      :visible.sync="attachmentVisible"
      @form:saved="getItemData"
    />
    <update-version
      v-model="chuan"
      :visible.sync="versionVisible"
      @form:saved="getItemData"
    />

    <el-dialog
      title="删除"
      :visible.sync="delBranchVisible"
      :close-on-click-modal="false"
      append-to-body
      @close="onCloseDelBranch"
      width="30%"
    >
      <el-form
        ref="delBranchItemForm"
        label-width="100px"
        :model="delBranchItem"
        :rules="delBranchRules"
      >
        <el-form-item label="删除原因" prop="Desc">
          <el-input
            v-model.trim="delBranchItem.Desc"
            :autosize="{ minRows: 5 }"
            type="textarea"
            placeholder="请输入删除原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseDelBranch">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onDelBranchItem">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="删除"
      :visible.sync="delDriveVisible"
      :close-on-click-modal="false"
      append-to-body
      @close="onCloseDelDrive"
      width="30%"
    >
      <el-form
        ref="delDriveItemForm"
        label-width="100px"
        :model="delDriveItem"
        :rules="delDriveRules"
      >
        <el-form-item label="删除原因" prop="Desc">
          <el-input
            v-model.trim="delDriveItem.Desc"
            :autosize="{ minRows: 5 }"
            type="textarea"
            placeholder="请输入删除原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseDelDrive">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onDelDriveItem">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import UpdatePatch from "./detail--patch.vue";
import UpdateDrive from "./detail--drive.vue";
import UpdateAttachment from "./detail--attachment.vue";
import UpdateVersion from "./index--form.vue";

export default {
  components: {
    UpdatePatch,
    UpdateDrive,
    UpdateAttachment,
    UpdateVersion,
  },
  data() {
    return {
      chuan: {},
      item: {},
      reverseVersions: [],
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      loading: false,
      updateVisible: false,
      driveVisible: false,
      attachmentVisible: false,
      versionVisible: false,

      activeTab: "",
      // branchPager: {
      //   total: 0,
      //   page: 1,
      //   size: -1,
      // },
      // drivePager: {
      //   total: 0,
      //   page: 1,
      //   size: -1,
      // },

      delBranchItem: {
        ID: "",
        Desc: "",
        VersionID: "",
      },
      delBranchRules: {
        Desc: [
          { required: true, message: "删除原因不能为空", trigger: "blur" },
        ],
      },
      delBranchVisible: false,

      delDriveItem: {
        ID: "",
        Desc: "",
        VersionID: "",
      },
      delDriveRules: {
        Desc: [
          { required: true, message: "删除原因不能为空", trigger: "blur" },
        ],
      },
      delDriveVisible: false,
    };
  },
  mounted() {
    this.getItemData();
  },
  methods: {
    getItemData() {
      const params = {
        with: ["Versions.VersionFunctions", "BusinessType"],
      };
      this.$axios
        .get(`software/${this.$route.params.ID}`, { params })
        .then((response) => {
          this.item = response.data;
          this.item.Versions.reverse();
          this.item.Versions.forEach((ver) => {
            ver.VersionBranchs.reverse();
            ver.VersionDrives.reverse();

            this.$axios
              .get(`software/version/branch/publish/${ver.ID}`)
              // .get("software/version/branch/publish", {
              //   params: {
              //     where: {
              //       VersionID: ver.ID,
              //     },
              //     ...this.branchPager,
              //     order: ["name"],
              //   },
              // })
              .then((response) => {
                ver.PublishBranchs = response.data; //response.data.data;
                this.activeTab = "";
                this.activeTab = "tabBranch";
              })
              .catch(({ response }) => {
                this.$sys.alarmResponse(response);
              })
              .finally(() => {});

            this.$axios
              .get(`software/version/drive/publish/${ver.ID}`)
              // .get("software/version/drive/publish", {
              //   params: {
              //     where: {
              //       VersionID: ver.ID,
              //     },
              //     ...this.drivePager,
              //     order: ["name"],
              //   },
              // })
              .then((response) => {
                ver.PublishDrives = response.data; //response.data.data;
              })
              .catch(({ response }) => {
                this.$sys.alarmResponse(response);
              })
              .finally(() => {});
          });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleChange() {
      this.activeTab = "tabBranch";
    },

    onUpdatePatch(row) {
      this.chuan = row;
      this.updateVisible = true;
    },
    onUpdateDrive(row) {
      this.chuan = row;
      this.driveVisible = true;
    },
    onUpdateAttachment(row) {
      this.chuan = row;
      this.attachmentVisible = true;
    },
    onUpdateVersion(row) {
      this.chuan = row;
      this.versionVisible = true;
    },

    onBranchDeleteClick(row) {
      this.delBranchItem.Desc = "";
      this.delBranchItem.ID = row.ID;
      this.delBranchItem.VersionID = row.VersionID;
      this.delBranchVisible = true;
    },
    onDelBranchItem() {
      this.$refs.delBranchItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$axios
          .request({
            url: "software/version/branch/publish/delete",
            method: "post",
            data: {
              ID: this.delBranchItem.ID,
              Desc: this.delBranchItem.Desc,
            },
          })
          .then(() => {
            this.$axios
              .get(
                `software/version/branch/publish/${this.delBranchItem.VersionID}`
              )
              // .get("software/version/branch/publish", {
              //   params: {
              //     where: {
              //       VersionID: this.delBranchItem.VersionID,
              //     },
              //     ...this.branchPager,
              //   },
              // })
              .then((response) => {
                this.item.Versions.forEach((ver) => {
                  if (ver.ID === this.delBranchItem.VersionID) {
                    ver.PublishBranchs = response.data; //response.data.data;
                  }
                });

                this.$message.success("删除成功");
                this.onCloseDelBranch();
              })
              .catch(({ response }) => {
                this.$sys.alarmResponse(response);
              })
              .finally(() => {});
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          });
      });
    },
    onCloseDelBranch() {
      this.delBranchVisible = false;
      this.$refs.delBranchItemForm.resetFields();
    },

    onDriveDeleteClick(row) {
      this.delDriveItem.Desc = "";
      this.delDriveItem.ID = row.ID;
      this.delDriveItem.VersionID = row.VersionID;
      this.delDriveVisible = true;
    },
    onDelDriveItem() {
      this.$refs.delDriveItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$axios
          .request({
            url: "software/version/drive/publish/delete",
            method: "post",
            data: {
              ID: this.delDriveItem.ID,
              Desc: this.delDriveItem.Desc,
            },
          })
          .then(() => {
            this.$axios
              .get(
                `software/version/drive/publish/${this.delDriveItem.VersionID}`
              )
              // .get("software/version/drive/publish", {
              //   params: {
              //     where: {
              //       VersionID: this.delDriveItem.VersionID,
              //     },
              //     ...this.drivePager,
              //   },
              // })
              .then((response) => {
                this.item.Versions.forEach((ver) => {
                  if (ver.ID === this.delDriveItem.VersionID) {
                    ver.PublishDrives = response.data; //response.data.data;
                  }
                });

                this.$message.success("删除成功");
                this.onCloseDelDrive();
              })
              .catch(({ response }) => {
                this.$sys.alarmResponse(response);
              })
              .finally(() => {});
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          });
      });
    },
    onCloseDelDrive() {
      this.delDriveVisible = false;
      this.$refs.delDriveItemForm.resetFields();
    },
  },
};
</script>

<style scoped lang="scss">
.ds-detail {
  ::v-deep.el-timeline-item__tail {
    display: block !important;
  }
}
table th td,
table tr td {
  padding: 2px 5px;
  height: 30px;
  line-height: 30px;
}
.border-style {
  height: 28px;
  line-height: 28px;
  border-radius: 0 15px 15px 0;
  border-left: 3px solid #409eff;
  padding-left: 5px;
  margin-bottom: 10px;
  background-color: #ecf5ff;
  color: #409eff;
  font-size: 13px;
  font-weight: bolder;
}
</style>
